import(/* webpackMode: "eager" */ "/home/chronicleusa/public_html/chronicles-exhibits/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/chronicleusa/public_html/chronicles-exhibits/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/home/chronicleusa/public_html/chronicles-exhibits/src/app/(landing)/Queryform.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/chronicleusa/public_html/chronicles-exhibits/src/app/services/_components/Carousel.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/chronicleusa/public_html/chronicles-exhibits/src/app/services/_components/Parallax.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/chronicleusa/public_html/chronicles-exhibits/src/components/ui/footer.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/chronicleusa/public_html/chronicles-exhibits/src/components/ui/header.jsx");
